import React from 'react';
import Modal from 'react-bootstrap/Modal';

const AttachModal = ({ show, onHide, attachItems, attachName = 'attachment' }) => {
  const fileUrl = typeof attachItems === 'string' ? attachItems : '';

  const isPdf = fileUrl.startsWith('data:application/pdf');
  const isImage = fileUrl.startsWith('data:image/');

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <h5 className="modal-title">Attachments</h5>
      </Modal.Header>

      <Modal.Body>
        {!fileUrl ? (
          <div className="text-center text-muted py-4">No attachment available.</div>
        ) : isPdf ? (
          <iframe
            src={fileUrl}
            style={{ width: '100%', height: '80vh', border: 0 }}
            title="Invoice attachment"
          />
        ) : isImage ? (
          <div className="text-center">
            <img
              src={fileUrl}
              alt={attachName}
              style={{ maxWidth: '100%', maxHeight: '80vh', objectFit: 'contain' }}
            />
          </div>
        ) : (
          <div className="text-center py-4">
            <p className="mb-3">Preview is not available for this file type.</p>
            <a
              href={fileUrl}
              download={attachName}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary"
            >
              Open / Download Attachment
            </a>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default AttachModal;